import React, { useEffect, useState } from "react";
import TableHeader from "./table-header/EventEHRTableHeader";
import TableBody from "./table-body/EventEHRTableBody";
import EventEHRNewPagination from "../pagination/EventEHRNewPagination";
const VARIANTS = {
  SM: "sm",
  MD: "md",
  LG: "lg",
};

const Table = ({
  selectProps = {
    isSelectAll: false,
    onSelectAll: () => {},
    isSelectable: false,
    onSelectRowsCb: () => {},
    selectIdentifier: "",
  },
  noDataFoundMessage = "No data found!",
  columns,
  rows = [],
  sorting,
  paginationProps = {
    isPagination: false,
    onPageChange: () => {},
    handleChangeRowsPerPage: () => {},
  },
  variant = "md",
  tableHeaderCustomclasses,
  overflowX, // for overflow overriding
}: any) => {
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (selectProps.onSelectRowsCb) {
      selectProps.onSelectRowsCb(selectedRows);
    }
  }, [selectedRows]);

  const selectKey = selectProps?.selectIdentifier ?? "";
  const rowIdsKey = (rows ?? [])
    .map((r: Record<string, unknown>) => r?.[selectKey])
    .join(",");

  useEffect(() => {
    setSelectedRows([]);
  }, [rowIdsKey]);

  const getVarient = () => {
    switch (variant) {
      case VARIANTS.SM:
        return "px-4 py-[8px]";
      case VARIANTS.MD:
        return "px-5 py-3";
      default:
        return "px-5 py-4";
    }
  };

  const selectAllCb = () => {
    if (selectProps?.onSelectAll) {
      selectProps?.onSelectAll([]);
    }

    if (selectedRows.length === rows.length) {
      return setSelectedRows([]);
    }
    setSelectedRows(rows);
  };

  useEffect(() => {
    if (!selectProps?.isSelectAll) {
      setSelectedRows([]);
    }
  }, [selectProps?.isSelectAll]);

  return (
    <div className="flex flex-1 flex-col justify-between w-full">
      <div
        className={`overflow-x-auto`} // Default Tailwind class
        style={{ overflowX }} // Overrides if passed as a prop
      >
        <table className="w-full">
          <TableHeader
            selectProps={selectProps}
            selectAllCb={selectAllCb}
            columns={columns}
            sorting={sorting}
            allChecked={rows.length > 0 && selectedRows.length === rows.length}
            getVarient={getVarient}
            tableHeaderCustomclasses={tableHeaderCustomclasses}
          />
          {rows?.length > 0 ? (
            <TableBody
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              selectProps={selectProps}
              columns={columns}
              rows={rows}
              getVarient={getVarient}
            />
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-4 font-normal color-979797"
                  style={{ fontSize: "14px" }}
                >
                  {noDataFoundMessage}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      {paginationProps?.isPagination && rows?.length ? (
        <EventEHRNewPagination
          currentPage={paginationProps?.page}
          totalPages={paginationProps?.totalPages}
          rowsPerPageOptions={paginationProps.rowsPerPageOptions}
          totalCount={paginationProps.totalCount}
          limit={paginationProps.limit}
          onPageChangeCb={paginationProps.onPageChange}
          handleChangeRowsPerPage={paginationProps?.handleChangeRowsPerPage}
        />
      ) : null}
    </div>
  );
};

export default Table;
